/*
 * bd-sample-gate.js
 *
 * The enforcement half of snippets/bd-sample-gate.liquid — see that file for the
 * rule and why it exists at the cart rather than on the sample button.
 *
 * This is a real asset rather than an inline <script> in the snippet because the
 * snippet renders inside <cart-items>, which the drawer and the cart page
 * re-render over AJAX. A <script> arriving through innerHTML never executes, so
 * an inline copy would be dead on exactly the path that matters most: a shopper
 * on a collection page adding a gated sample from a card, where the page loaded
 * with a clean cart and the gate first appears over AJAX. Loading it from
 * layout/theme.liquid means the observer is already running whenever that
 * happens.
 */
(function () {
  if (window.__bdSampleGateInit) return;
  window.__bdSampleGateInit = true;

  /*
   * Liquid renders the checkout controls already blocked, but only <cart-items>
   * is re-rendered over AJAX — the drawer footer and the cart summary are not.
   * So adding a gated sample from a card, or removing one from the cart, would
   * otherwise leave the button in whatever state the last full page load put it
   * in. This mirrors the panel's presence onto the controls on every DOM change.
   *
   * The express buttons matter as much as the main one: Shop Pay and friends go
   * straight to payment without passing the cart, so a gate they ignore is not a
   * gate.
   */
  function syncCheckoutControls() {
    var blocked = !!document.querySelector('[data-bd-sample-gate]');
    // An emptied cart disables checkout for its own reasons. Release only the
    // hold this gate placed, never someone else's.
    var emptied = !!document.querySelector('cart-items[data-empty="true"]');

    document.querySelectorAll('[name="checkout"], [data-bd-sc-submit]').forEach(function (btn) {
      if (blocked) {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
      } else if (btn.dataset.bdSampleGateHeld === 'true' && !emptied) {
        btn.disabled = false;
        btn.removeAttribute('aria-disabled');
      }
      btn.dataset.bdSampleGateHeld = blocked ? 'true' : 'false';
    });

    document.querySelectorAll('.dynamic-cart-btns').forEach(function (el) {
      // Same rule as the button above: release only the hold this gate placed,
      // so a container the theme hid for its own reasons stays hidden.
      if (blocked) {
        el.hidden = true;
      } else if (el.dataset.bdSampleGateHeld === 'true') {
        el.hidden = false;
      }
      el.dataset.bdSampleGateHeld = blocked ? 'true' : 'false';
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-bd-sample-quantity-reduce]');
    if (!button) return;
    event.preventDefault();
    button.disabled = true;
    window.BDSampleQuantity.reduce()
      .then(function () { window.location.reload(); })
      .catch(function (error) { button.disabled = false; alert(error.message); });
  });

  syncCheckoutControls();

  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      syncCheckoutControls();
    });
  }).observe(document.body, { childList: true, subtree: true });

  /*
   * Removing the blocked lines is the way out of this panel, so it must not
   * dead-end either. Lines are removed by key one at a time — /cart/change.js
   * reindexes on every write, so a batched line-number call would remove the
   * wrong rows — and then the page is reloaded so the drawer, the cart page and
   * the checkout button all re-render from the real cart.
   */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bd-sample-gate-remove]');
    if (!btn) return;

    var panel = btn.closest('[data-bd-sample-gate]');
    if (!panel) return;

    var keys = (panel.dataset.bdSampleGateKeys || '').split(',').filter(Boolean);
    if (!keys.length) return;

    btn.disabled = true;

    keys.reduce(function (chain, key) {
      return chain.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        });
      });
    }, Promise.resolve())
      .then(function () { window.location.reload(); })
      .catch(function () {
        btn.disabled = false;
        alert('Could not remove those samples. Please try again, or give us a call.');
      });
  });
})();

